var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.05 9a4.5 4.5 0 1 0-2.733-.924A6.75 6.75 0 0 0 .299 14.25c0 .414.336.75.75.75h12a.75.75 0 0 0 .75-.75 6.74 6.74 0 0 0-2.285-5.062.75.75 0 1 0-.992 1.124 5.24 5.24 0 0 1 1.724 3.188H1.852A5.25 5.25 0 0 1 7.05 9m-3-4.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0",
    clipRule: "evenodd"
  })));
};
export default SvgProfile;